import {styled} from '@mui/material/styles';

export const PageLayout = styled('div')({
  padding: '0 42px 0 42px',
  maxHeight: '100vh',
  minHeight: '100vh',
  overflow: 'auto',
});
